import reframe from 'reframe.js';
import Modal from './Modal';

export default class MasonryVideo {
  constructor(el, event) {
    this.el = el;
    this.modal = null;

    const { currentTarget: target } = event;
    const modalID = target.dataset.masonryVideo;
    const modalEl = this.el.querySelector(`[data-modal-id="${modalID}"]`);

    this.modal = new Modal({
      el: modalEl,
      callbacks: {
        onOpen: ({ modal, contents }) => this._open({
          modal,
          contents,
        }),
        onClose: () => this._close(),
      },
    });

    this.modal.open();
  }

  onSectionUnload() {
    if (this.modal) {
      this.modal.close();
    }
  }

  _open({ modal, contents }) {
    const video = modal.querySelector('[data-masonry-video]');

    try {
      contents.innerHTML = JSON.parse(video.innerText);

      reframe(contents);
      reframe(contents.querySelectorAll('iframe'));

      this.modal.showModal();
    } catch {
      console.warn('Unable to parse contents of video');
    }
  }

  _close() {
    this.modal = null;
  }
}
